import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-locize-backend'
import { locizePlugin } from 'locize'
import { initReactI18next } from 'react-i18next'

const projectId = process.env.LOCIZE_PROJECT_ID
const apiKey = process.env.LOCIZE_API_KEY

if (!projectId) {
  throw new Error('Missing Locize project ID.')
}

export const locizeOptions = {
  projectId,
  referenceLng: 'en',
  cdnType: 'pro',
  // Absent from every deployed build. Reading published translations needs only the project
  // id; the key authorises writes, so it is supplied to local builds only.
  ...(apiKey ? { apiKey } : {}),
}

// The detector keeps any `?lng=` or stored value, and a malformed tag such as `en_US` makes every
// Intl call given `i18n.language` throw. Canonicalise what it finds; an empty string is no match,
// so a tag that is not BCP 47 falls through to the fallback language.
const toLocaleTag = (lng: string): string => {
  try {
    return Intl.getCanonicalLocales(lng.replace(/_/g, '-'))[0] ?? ''
  } catch {
    return ''
  }
}

i18n
  .use(locizePlugin)
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    // With `load: 'languageOnly'` these match on the language part, so en-GB and de-DE pass.
    supportedLngs: ['en', 'de'],
    load: 'languageOnly',
    detection: { convertDetectedLanguage: toLocaleTag },
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
  })

export default i18n
